class RiveAnimation {
	constructor() {
		this.riveFileSource = mcubeArgs.themeLink + "/rive/smartto.riv";

		fetch(this.riveFileSource)
			.then(response => {
				response.arrayBuffer().then(data => {
					this.riveFile = new Uint8Array(data);
					this.resizedAnimations = [];

					// burger animation
					this.headerBurgerAnimation();

					// ajout des <TAG> pour les liens + surtitre dans les .rich-text
					this.addRichTextRiveAnimation();

					// initialisation globale des Rives
					this.initAnimation();

					// lien d'invitation au scroll en pâge d'accueil
					this.initInvitToScroll();
				});
			});
	}

	headerBurgerAnimation(){

		this.mainNavOpen = false;

		const burgerContainer = document.querySelector('.header-burger');
		const burger = burgerContainer.querySelector('.rive-container');
		burger.innerHTML = `<canvas class="rive"></canvas>`;
		burger.canvas = burger.querySelector("canvas");
		this.setCanvasSize(burger);
		burger.animation = new rive.Rive({
			buffer: this.riveFile,
			artboard: "anim-menu",
			stateMachines: "state-machine",
			canvas: burger.canvas,
			autoplay: true,
			layout: new rive.Layout({
				fit: rive.Fit.Contain
			}),
			onLoad: (_) => {
				const inputs = burger.animation.stateMachineInputs('state-machine');
				const bumpHover = inputs.find(i => i.name === 'hover');
				const bumpOut = inputs.find(i => i.name === 'out');
				const bumpClick = inputs.find(i => i.name === 'click');

				gsap.set(burger.canvas,{
					opacity: 1
				});

				burgerContainer.addEventListener( "mouseenter", () => {
					bumpHover.fire();
				});

				burgerContainer.addEventListener( "mouseleave", () => {
					bumpOut.fire();
				});

				burgerContainer.addEventListener( "click", () => {
					bumpClick.fire();
					if(!this.mainNavOpen) {
						navigation.navigationTimeline.play();
						smoother.paused(true);
						this.mainNavOpen = true;
					} else{
						navigation.hideSubNav();
						if( navigation.navMain.querySelector('.menu-item--lev1.current-menu-ancestor') ){
							let event = new MouseEvent('customEventLeave');
							navigation.navMain.querySelector('.menu-item--lev1.current-menu-ancestor').dispatchEvent(event);
						}
						navigation.navigationTimeline.reverse();
						smoother.paused(false);
						this.mainNavOpen = false;
					}
					document.body.classList.toggle('main-nav-open', !document.body.classList.contains('main-nav-open'));
				});
			}
		});
		this.resizedAnimations.push(burger);

	}

	initAnimation(){

		const animations = document.querySelectorAll(".rive-animation");
		animations.forEach(animation => {

			ScrollTrigger.create({
				trigger: animation,
				start: 'top bottom',
				onToggle: (e) => {

					if (e.isActive) {

						if (animation.buildDone) {
							return;
						}

						animation.innerHTML = `<canvas class="rive"></canvas>`;
						animation.canvas = animation.querySelector("canvas");
						this.setCanvasSize(animation);

						let artBoard = animation.dataset.riveName;
						let section = animation.closest('.section');
						if ((section && !section.classList.contains('section-dark-green') && !section.classList.contains('section-texture') && !animation.dataset.riveAnimationForceWhite) || animation.dataset.riveAnimationForceDark) {
							artBoard = artBoard + "-dark";
						}

						animation.animation = new rive.Rive({
							buffer: this.riveFile,
							artboard: artBoard,
							canvas: animation.canvas,
							stateMachines: "state-machine",
							autoplay: true,
							layout: new rive.Layout({
								fit: rive.Fit.Contain
							}),
							onLoad: (_) => {
								animation.buildDone = true;
								const inputs = animation.animation.stateMachineInputs('state-machine');
								if( inputs ) {
									animation.bumpIn = inputs.find(i => i.name === 'in');
									animation.bumpOut = inputs.find(i => i.name === 'out');
									if (animation.bumpIn) {
										this.switchRiveAnimation(animation);
									}
								}
							},
							onStateChange: (_) => {
								setTimeout(() => {
									gsap.set(animation.canvas, {
										opacity: 1
									});
								}, 150);
							}
						});

						this.resizedAnimations.push(animation);
					}

				}
			});

		});

	}

	switchRiveAnimation(animation){

		let container = animation.closest('.rive-object-container');
		let tl = null;
		switch( animation.dataset.riveAnimation ){
			
			case 'hover-in-out':
				animation.bumpOut.fire();
				break;

			case 'hover-out-in':
				animation.bumpIn.fire();
				container.addEventListener("mouseenter", () => {
					animation.bumpOut.fire();
					setTimeout( () => {
						animation.bumpIn.fire();
					}, 500);
				});
				return false;

			case 'custom-in-out':
				container.addEventListener("customEventEnter", () => {
					animation.bumpIn.fire();
				});
				container.addEventListener("customEventLeave", () => {
					animation.bumpOut.fire();
				});
				return false;

			case 'slider-arrow-hover':
				container.addEventListener("mouseenter", () => {
					animation.bumpIn.fire();
				});
				return false;

			case 'button':
				tl = gsap.timeline({
					onReverseComplete: () => {
						setTimeout( () => {
							animation.bumpOut.fire();
						}, 100);
					}
				}).pause();

				let text = container.querySelector('.label');
				let rive = container.querySelector('.rive-object');
				let xRive = (container.classList.contains('btn-back')) ? - text.offsetWidth + (animation.canvas.offsetWidth / 4) : text.offsetWidth - animation.canvas.offsetWidth / 4.5;
				let xLabel = (container.classList.contains('btn-back')) ? rive.offsetWidth/1.5 : -rive.offsetWidth/1.5;

				tl.to(rive, {
					x: xRive,
					ease: "none",
					duration: 0.25,
					overwrite: true,
					immediateRender: true
				});
				tl.to(text, {
					x: xLabel,
					ease: "none",
					duration: 0.25,
					overwrite: true,
					immediateRender: true
				}, 0);
				break;
			
			default:
				break;
		}

		if( container ) {
			container.addEventListener("mouseenter", () => {
				animation.bumpIn.fire();
				if( tl ){
					tl.play();
				}
			});
			container.addEventListener("mouseleave", () => {
				animation.bumpOut.fire();
				if( tl ){
					tl.reverse();
				}
			});
		}

	}

	addRichTextRiveAnimation(){

		const links = document.querySelectorAll(".big-link, .simple-link, .form-actions button");
		links.forEach(link => {

			let text = "<span class='label'>" + link.innerHTML + "</span>";
			link.innerHTML = text;

			let riveElementContainer = document.createElement('span');
			riveElementContainer.classList.add('rive-animation');
			riveElementContainer.classList.add('rive-object');
			riveElementContainer.dataset.riveName = "arrow-big-link";
			riveElementContainer.dataset.riveAnimation = "hover-in-out";

			if( link.tagName === "BUTTON" ){
				riveElementContainer.dataset.riveAnimationForceWhite = "true";
				riveElementContainer.dataset.riveAnimation = "hover-out-in";
			}

			link.append(riveElementContainer);
			link.classList.add('rive-object-container');

		});

		const buttons = document.querySelectorAll(".btn-go, .btn-back");
		buttons.forEach(button => {

			let text = "<span class='label'>" + button.innerHTML + "</span>";
			button.innerHTML = text;

			let riveElementContainer = document.createElement('span');
			riveElementContainer.classList.add('rive-animation');
			riveElementContainer.classList.add('rive-object');
			riveElementContainer.dataset.riveName = "arrow-btn";
			riveElementContainer.dataset.riveAnimation = "button";
			// riveElementContainer.dataset.riveAnimationForceDark = "true";

			button.append(riveElementContainer);
			button.classList.add('rive-object-container');

			let dataLink = button.closest('[data-link]');
			if( dataLink ){
				dataLink.addEventListener( "mouseenter", () => {
					let event = new MouseEvent('mouseenter');
					button.dispatchEvent(event);
				});
				dataLink.addEventListener( "mouseleave", () => {
					let event = new MouseEvent('mouseleave');
					button.dispatchEvent(event);
				});
			}

		});

		const superTitles = document.querySelectorAll(".supertitle:not(.no-circle)");
		superTitles.forEach(title => {
			let text = "<span class='label'>" + title.innerHTML + "</span>";
			title.innerHTML = text;

			let riveElementContainer = document.createElement('span');
			riveElementContainer.classList.add('rive-animation');
			riveElementContainer.dataset.riveName = "anim-dots";
			title.prepend(riveElementContainer);
		});

	}

	initInvitToScroll() {

		const animation = document.querySelector(".rive-invite-to-scroll-animation");

		if (!animation)
			return;

		ScrollTrigger.create({
			trigger: animation,
			start: 'top bottom',
			onToggle: (e) => {
				if (e.isActive) {

					if (animation.buildDone) {
						return;
					}

					animation.innerHTML = `<canvas class="rive"></canvas>`;
					animation.canvas = animation.querySelector("canvas");
					this.setCanvasSize(animation);

					animation.animation = new rive.Rive({
						buffer: this.riveFile,
						artboard: "scroll-down",
						stateMachines: "state-machine",
						canvas: animation.canvas,
						autoplay: true,
						layout: new rive.Layout({
							fit: rive.Fit.Contain
						}),
						onLoad: (_) => {
							animation.buildDone = true;
							gsap.to(animation.canvas, {
								opacity: 1,
							});
						}
					});

					this.resizedAnimations.push(animation);
				}
			}
		});

	}

	setCanvasSize(parent) {
		parent.canvas.setAttribute("width", parent.clientWidth * Math.min(window.devicePixelRatio, 2));
		parent.canvas.setAttribute("height", parent.clientHeight * Math.min(window.devicePixelRatio, 2));
	}

	resize() {
		this.resizedAnimations.forEach(element => {
			this.setCanvasSize(element);
			element.animation.layout = new rive.Layout({fit: rive.Fit.Contain});
		});
	}
}
